import {isString} from 'lodash-es';
import {json} from '../core/data-source/json.mapper';
import {getStrings} from '../core/lang';

const S: any = getStrings();
export class MetadataRecord {
    @json({
        jsonName: 'title',
        mapper: {
            from: (title: any, data: any) => {
                if (title) {
                    if (isString(title)) {
                        title = title && title.indexOf('{') != -1 ? JSON.parse(title) : {en: title};
                    }
                    return S._lang_ in title ? title[S._lang_] : title.en;
                }
                return data.name;
            }
        }
    })
    displayName: string;

    @json({
        jsonName: 'title',
        mapper: {
            from: (title: any, data: any) => {
                if (title) {
                    if (isString(title)) {
                        return title && title.indexOf('{') != -1 ? JSON.parse(title) : {en: title};
                    }
                }
                return {en: data.name};
            }
        }
    })
    translates: any;

    @json() group: string;

    @json() groupName: string;

    @json() name: string;

    @json() nullable: boolean;

    @json() order: number;

    @json() readOnly: boolean;

    @json() required: boolean;

    @json() title: any;

    @json() type: string;
}
